import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";

export const StyledTimeTemplateWithExplanation = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "time-template-with-explanation",
  },
)`
  position: relative;
  width: 100%;
`;
